import { z } from "zod";

/**
 * Role hierarchy, lowest → highest privilege.
 * Index in this array == privilege level.
 *
 * Kept in a leaf module (no cross-imports from `./index.js`) so that other
 * shared sub-modules — e.g. `./forms.js`, `./overview.js` — can depend on
 * the role primitives without creating a circular import cycle through
 * the barrel.
 */
export const ROLES = [
  "applicant",
  "recruit",
  "member",
  "staff_in_training",
  "staff",
  "senior_staff",
  "junior_administration",
  "administration",
  "senior_administration",
  "head_administration",
] as const;

export const RoleSchema = z.enum(ROLES);
export type Role = z.infer<typeof RoleSchema>;

/** Cross-cutting team memberships (not part of the linear hierarchy). */
export const TEAMS = ["internal_affairs"] as const;
export const TeamSchema = z.enum(TEAMS);
export type Team = z.infer<typeof TeamSchema>;

export function rolePrivilege(role: Role): number {
  return ROLES.indexOf(role);
}

export function hasAtLeast(role: Role, min: Role): boolean {
  return rolePrivilege(role) >= rolePrivilege(min);
}
